import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row as AntdRow, message, Modal, Button, Grid } from 'antd';
import styled from 'styled-components';
import { isLocaleEnglish } from 'utils/languageUtils';

import { HomeContext } from 'contexts/home/context';
import { GreetingSection, NewsSection, EbInbox } from './components';
import { IconCard, type IconCardProps } from 'components/card';
import FourItemColumn from 'components/fourItemColumn';
import NewClaimIcon from 'assets/images/home/new-claim.svg';
import ShieldIcon from 'assets/images/home/shield.svg';
import CalendarIcon from 'assets/images/home/calendar.svg';
import ClaimRecordsIcon from 'assets/images/home/claim-records.svg';
import { Spinner } from 'components';
import { useLocation } from 'react-router-dom';
const { useBreakpoint } = Grid;
import Close from 'assets/images/liHome/close.svg';
import { usePostPromPopUp, useGetPromPopUp } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks';
import { sessionStorageService } from 'utils/SessionStorageService';
import './HomePage.less';

const HomePageContainer = styled.div`
  margin: 0 16px;
`;

const Row = styled(AntdRow)`
  margin-bottom: 2.5rem;
`;

interface LocationState {
  fileNotFound: boolean;
}
interface GetPromDetail {
  popupGroupId: string;
  popupId: string;
  messageEn: string;
  messageTc: string;
  targetAction: string;
  linkTc: string;
  linkEn: string;
}
interface GetPromPopUpProps {
  promotionDontShowAgain: string;
  mfaDontShowAgain?: string;
  promotionBannerPosition: number;
  promotionWEB: GetPromDetail;
  promotionIOS: GetPromDetail;
  promotionAndroid: GetPromDetail;
  mfaWEB?: GetPromDetail;
  mfaIOS?: GetPromDetail;
  mfaAndroid?: GetPromDetail;
}

function HomePage() {
  const { t, i18n } = useTranslation();
  const { state, showTips } = useContext(HomeContext);
  const { userAccess } = state;
  const location = useLocation();
  const [isFileNotFound, setIsFileNotFound] = useState((location.state as LocationState)?.fileNotFound || false);
  const [randoms, setRandoms] = useState(Math.random());
  const { token } = useKeycloakReady();

  const iconCardItems: IconCardProps[] = [];
  const { xs } = useBreakpoint();
  const [showProm, setShowProm] = useState<boolean>(false);
  const isEnglish = isLocaleEnglish(i18n.language);
  const [promAction, setPromAction] = useState<string>('');
  const [promData, setPromData] = useState<GetPromPopUpProps | null>();
  const [promPop, setPromPop] = useState<string>(sessionStorageService.get('ebPromPop') || '');
  const { data: PromData, shouldFetch: shouldfetchProm } = useGetPromPopUp('useGetPromPopUp', token ?? '');

  const { shouldFetch: shouldfetchPromPost } = usePostPromPopUp(
    'usePostPromPopUp' + randoms,
    token ?? '',
    promData?.mfaWEB?.popupGroupId ?? '',
    promData?.mfaWEB?.popupId ?? '',
    'PROMO',
    promAction,
  );
  if (userAccess?.panel) {
    iconCardItems.push({
      to: '/network-doctors',
      icon: ShieldIcon,
      title: t('home.findNetworkDoctorTitle'),
      description: t('home.findNetworkDoctorDescription'),
    });
  }

  if (userAccess?.teladoc) {
    iconCardItems.push({
      to: '/teladoc-booking',
      icon: CalendarIcon,
      title: t('home.bookOnlineDoctorTitle'),
      description: t('home.bookOnlineDesc'),
    });
  }

  if (userAccess?.submitClaim) {
    iconCardItems.push({
      to: '/claims/new',
      icon: NewClaimIcon,
      title: t('home.fileANewClaimTitle'),
      description: t('home.fileANewClaimDescription'),
    });
  }

  iconCardItems.push({
    to: '/claims',
    icon: ClaimRecordsIcon,
    title: t('home.checkClaimRecords'),
    description: t('home.checkClaimRecordsDescription'),
  });

  useEffect(() => {
    if (isFileNotFound) {
      message.error(t('common.error.fileNotFound'));
      setIsFileNotFound(false);
    }
  }, [isFileNotFound, t]);

  // const handleConfirm = () => {
  //   setPromAction('PURCHASE');
  //   setShowProm(false);
  //   // setPromNum(promData?.promotionBannerPosition);
  //   window.open(i18n.language == 'en' ? promData?.mfaWEB?.linkEn : promData?.mfaWEB?.linkTc, '_blank');
  // };
  const handleCancel = () => {
    // console.log('点击了取消按钮');
    setPromAction('DONTSHOW');
    setShowProm(false);
  };
  const handleClose = () => {
    // console.log('点击了关闭按钮');
    // setPromAction('CLOSE');
    // setShowProm(false);
    // setPromAction('CONFIRM');
    setShowProm(false);
    // setPromNum(promData?.promotionBannerPosition);
  };
  useEffect(() => {
    if (!promPop) {
      shouldfetchProm(true);
    }
  }, [promPop, shouldfetchProm]);
  useEffect(() => {
    if (PromData) {
      setPromData(PromData);
      shouldfetchProm(false);
      // if (PromData.promotionDontShowAgain == 'Y') {
      // setPromPop('true');
      // sessionStorageService.set('promPop', 'true');
      // }
    }
  }, [PromData, shouldfetchProm]);
  useEffect(() => {
    if (promAction) {
      setRandoms(Math.random());
      shouldfetchPromPost(true);
    }
  }, [promAction, shouldfetchPromPost]);
  useEffect(() => {
    if (!showTips) {
      if (promData?.mfaDontShowAgain == 'Y') {
        setShowProm(true);
        setPromPop('true');
        sessionStorageService.set('ebPromPop', 'true');
      } else {
        setShowProm(false);
      }
    }
  }, [showTips, promData]);
  useEffect(() => {
    return () => {
      setPromData(null);
    };
  }, []);
  return (
    <HomePageContainer style={{ position: 'relative' }}>
      <EbInbox></EbInbox>
      <GreetingSection />
      {
        <Row gutter={[{ xs: 8, sm: 16, md: 24 }, 16]} wrap>
          {userAccess ? (
            iconCardItems.map(({ title, ...props }) => (
              <FourItemColumn key={title}>
                <IconCard level={4} title={title} {...props} />
              </FourItemColumn>
            ))
          ) : (
            <Spinner />
          )}
        </Row>
      }
      <NewsSection />
      <Modal
        open={showProm}
        onCancel={handleClose}
        className="e-notice-modal home-eb"
        width={xs ? 'calc(100% - 32px)' : '720px'}
        closeIcon={<img src={Close} />}
        footer={[
          // <Button key="cancel" onClick={handleCancel}>
          //   {t('common.dontshow')}
          // </Button>,
          <Button
            key="submit"
            type="primary"
            style={{
              border: '2px solid #c21b17 ',
              color: '#fff',
            }}
            onClick={handleCancel}
          >
            {t('common.dontshow')}
          </Button>,
        ]}
      >
        <div>
          <div
            className="prom-content"
            dangerouslySetInnerHTML={{
              __html: isEnglish ? promData?.mfaWEB?.messageEn ?? '' : promData?.mfaWEB?.messageTc ?? '',
              // __html:
              //   "<p class='bold'>限時優惠！🎉</p>  <p>使用會員號「NEWS2506」購買<span class='bold'>單次旅遊計劃</span>或<span class='bold black'>家居保險</span>可享7折優惠！</p><p>經 GenBRAVO 人壽版面首頁點擊相關優惠連結，即轉到 Bravo 網站購買！</p>",
            }}
          />
          {/* <Title level={5} className={`red-font ${lg ? 'font-size26' : 'font-size22'}`}>
            {isEnglish ? promData?.promotionWEB?.messageEn : promData?.promotionWEB?.messageTc}
          </Title> */}
          {/* <Text className={`${lg ? 'font-size22' : 'font-size17'}`}>{t('life.policies.confirmGreenDesc')}</Text> */}
        </div>
      </Modal>
    </HomePageContainer>
  );
}

export default HomePage;
